<style scoped>
html {
  font-family: "Inter", sans-serif;
}
.pagination >>> li > button {
  color: rgb(0 43 106);
}

.pagination >>> li.active > button {
  color: white !important;
  background-color: rgb(0 43 106) !important;
}
.pagination >>> li > button:hover {
  color: white;
  background-color: rgb(0 43 106) !important;
}

.clickable {
  cursor: pointer;
  transition: background-color 0.2s;
}
.mt-100 {
  margin-top: 100px;
}

.loader {
  text-align: center;
}
.breadcrumb-item a {
  color: rgb(0 147 221) !important;
}
.breadcrumb-item {
  font-size: 1rem;
  font-weight: 600;
}
.breadcrumb {
  display: flex;
  box-shadow: none;
  border: none;
}
</style>
<template>
  <b-container
    fluid
    class="main-wrapper"
    style="
      color: black;
      padding-bottom: 5%;
      font-family: 'Inter', 'sans-serif' !important;
    "
  >
    <b-row class="ml-5 mr-5 mt-5 mb-0">
      <b-col class="ml-5 mr-5">
        <b-breadcrumb :items="breadcrumbs" class="breadcrumbs"></b-breadcrumb>
        <h2 class="mt-4 mb-0">Berita dan Kegiatan</h2>
        <p class="mt-0 mb-4">
          Berita terkait kegiatan statistik hayati yang diselenggarakan oleh
          Badan Pusat Statistik.
        </p>
      </b-col></b-row
    >
    <b-row
      class="ml-5 mr-5 mb-0"
      style="padding-left: 3.5em; padding-right: 3.5em"
    >
      <b-col cols="12" v-if="isLoading">
        <b-card class="mb-4 shadow-none">
          <b-skeleton animation="wave" width="85%"></b-skeleton>
          <b-skeleton animation="wave" width="55%"></b-skeleton>
          <b-skeleton animation="wave" width="70%"></b-skeleton>
        </b-card>
        <b-card class="mb-4 shadow-none">
          <b-skeleton animation="wave" width="85%"></b-skeleton>
          <b-skeleton animation="wave" width="55%"></b-skeleton>
          <b-skeleton animation="wave" width="70%"></b-skeleton>
        </b-card>
        <b-card class="mb-4 shadow-none">
          <b-skeleton animation="wave" width="85%"></b-skeleton>
          <b-skeleton animation="wave" width="55%"></b-skeleton>
          <b-skeleton animation="wave" width="70%"></b-skeleton>
        </b-card>
        <b-card class="mb-4 shadow-none">
          <b-skeleton animation="wave" width="85%"></b-skeleton>
          <b-skeleton animation="wave" width="55%"></b-skeleton>
          <b-skeleton animation="wave" width="70%"></b-skeleton>
        </b-card>
        <b-card class="mb-4 shadow-none">
          <b-skeleton animation="wave" width="85%"></b-skeleton>
          <b-skeleton animation="wave" width="55%"></b-skeleton>
          <b-skeleton animation="wave" width="70%"></b-skeleton>
        </b-card>
      </b-col>
      <b-col v-else cols="12">
        <p>
          Menampilkan {{ (page - 1) * size }}-{{
            (page - 1) * size + size
          }}
          dari {{ totalElements }} Berita
        </p>
        <b-card
          @click="onRowClick(item.slug)"
          v-for="item in news"
          :key="item.id"
          class="clickable mb-4 shadow-none"
        >
          <b-row>
            <b-col cols="2">
              <b-img
                class="crop-image"
                fluid
                width="180"
                height="200"
                :src="getBase64Image(item.thumbnail)"
                alt="Left image"
              ></b-img>
            </b-col>
            <b-col cols="10">
              <small>
                <b-badge v-if="item.isDone" variant="primary"
                  >{{ item.formattedDate }} | Telah Dilaksanakan</b-badge
                >
                <b-badge v-else variant="success"
                  >{{ item.formattedDate }} | Akan Datang</b-badge
                ></small
              >
              <p style="color: rgb(0 60 128); font-size: 1.5rem">
                {{ item.title }}
              </p>
              <div v-html="item.preview"></div>
              <small style="color: rgb(0 60 128)"
                ><a :href="'/' + projectName + '/news/' + item.slug"
                  >Selengkapnya</a
                ></small
              >
            </b-col>
          </b-row>
        </b-card>
        <b-pagination
          align="right"
          size="sm"
          v-model="page"
          :per-page="size"
          :total-rows="totalElements"
          @page-click="changePage"
          class="pagination"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-container>
</template>
<style scoped>
.crop-image {
  width: 150px; /* Pastikan gambar memenuhi ukuran elemen */
  height: 200px; /* Atur tinggi sesuai kebutuhan */
  object-fit: cover; /* Crop gambar agar sesuai ukuran elemen */
  overflow: hidden; /* Sembunyikan bagian gambar yang keluar */
}
</style>
<script>
import sdiService from "../../services/SdiService";
// import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";
export default {
  name: "Data",
  props: {
    projectName: {
      type: String,
      required: true,
    },
  },
  data: () => {
    return {
      isLoading: true,
      breadcrumbs: [
        {
          text: "Beranda",
          to: "/sshi",
        },
        {
          text: "Berita dan Kegiatan",
          active: true,
        },
      ],
      news: [],
      title: "",
      size: 10,
      page: 0,
      totalElements: 21,
      totalPages: 3,
    };
  },
  components: {
    // vSelect,
  },
  mounted() {
    this.loadData(this.page);
  },
  created() {
    // this.loadJenisData("jenis data");
  },
  computed: {},
  methods: {
    onRowClick(item) {
      this.$router.push("/" + this.projectName + "/news/" + item);
    },
    changePage(event, page) {
      if (event) {
        this.loadData(page - 1);
      }
    },
    getBase64Image(base64) {
      // Menambahkan awalan data:image/jpeg;base64, jika Base64 tidak mengandung awalan
      const mimeType = this.getMimeType(base64);
      const fullBase64 = `data:${mimeType};base64,${base64}`;
      return fullBase64;
    },
    getMimeType(base64) {
      // Cek tipe MIME dari Base64 string, bisa dikembangkan lebih lanjut
      if (base64.startsWith("iVBOR")) {
        return "image/png"; // Jika Base64 string diawali dengan 'iVBOR' berarti PNG
      } else if (base64.startsWith("/9j/")) {
        return "image/jpeg"; // Jika Base64 string diawali dengan '/9j/' berarti JPEG
      }
      return "image/jpeg"; // Default ke JPEG jika tidak diketahui
    },
    async loadData(page) {
      await sdiService
        .getNews(page, this.size, this.projectName, this.title)
        .then(
          (response) => {
            this.totalElements = response.data.totalElements;
            this.totalPages = response.data.totalPages;
            this.news = response.data.content;
            this.news = this.news.map((item) => {
              return {
                ...item,
                isDone: new Date() > new Date(item.doneAt) ? true : false,
                formattedDate: new Intl.DateTimeFormat("id-ID", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                }).format(new Date(item.postAt)),
                preview:
                  item.content
                    .slice(0, 500)
                    .replace("</p>", "")
                    .replace("<br>", "")
                    .replace("<p>", "")
                    .replace("<p></p>", "") + "...",
              }; // Contoh logika untuk 'age'
            });
            this.isLoading = false;
            // console.log(response);
          },
          (error) => {
            console.log(error);
          }
        );
    },
  },
  watch: {},
};
</script>
